module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-from-left-cb4bfaf8c1af6cb2f12937307a43c7c2.svg";